import { IVan } from '../../../../../app/entities/Van'

export function updateVan(van: IVan) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/vans/`,
    body: van,
  }
}
